//     This code was generated by a Reinforced.Typings tool.
//     Changes to this file may cause incorrect behavior and will be lost if
//     the code is regenerated.

export enum CatalogVariantInputType {
	Alphanumeric = 0,
	Numeric = 1
}
